import script from "./AddProjectSupplierModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProjectSupplierModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddProjectSupplierModal.vue?vue&type=style&index=0&id=2bad83e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bad83e7"]])

export default __exports__